import React, { Component } from "react"
import PropTypes from "prop-types"
import { withCookies } from "react-cookie"
import {
  USER_EMAIL,
  TOP_DOMAIN,
} from "../CoreModules/SessionManagement/constants"
import { makeUnauthGetRequest } from "../utils/lambda/unauthRequests"
import {
  inputStyleClassName,
  buttonStyleClassName,
} from "../CoreModules/Login/authViews/styles"
import dictionary from "./dictionary"

const getBrandName = () => {
  const urlParts = window.location.host.split(".")
  const brandName = urlParts[urlParts.length - 2]

  return brandName
}

class Support extends Component {
  constructor() {
    super()
    this.state = {
      render: false,
      errorMessage: false,
    }
    this.email = React.createRef()
    this.redirect = this.redirect.bind(this)
    this.updateEmail = this.updateEmail.bind(this)
    this.submitEmail = this.submitEmail.bind(this)
  }

  componentDidMount() {
    const { title, favicon } = dictionary[getBrandName()]
    const link = document.querySelector("link[rel~='icon']")
    document.title = `${title} Helpdesk`
    link.href = favicon

    const { cookies } = this.props
    const all = cookies.getAll()
    if (all[USER_EMAIL] !== undefined) {
      this.redirect({ email: all[USER_EMAIL] })
    } else {
      this.setState({ render: true })
    }
  }

  updateEmail(input) {
    this.email = input
  }

  redirect({ email }) {
    const { cookies } = this.props
    const url = `/helpdesk_v1/lookup/${email}${window.location.search}`

    makeUnauthGetRequest({
      url,
      onSuccess: ({ hub_url }) => {
        cookies.set(USER_EMAIL, email, {
          domain: TOP_DOMAIN,
          path: "/",
        })
        window.location.replace(hub_url)
      },
      onFailure: (errorResponse) => {
        const { message } = errorResponse?.data?.error || {
          message: "",
        }
        this.setState({ errorMessage: message, render: true })
      },
    })
  }

  submitEmail(e) {
    e.preventDefault()
    this.setState({ errorMessage: false })
    this.redirect({ email: this.email.value })
  }

  render() {
    const { render, errorMessage } = this.state
    const { color, logo, title } = dictionary[getBrandName()]

    if (!render) {
      return null
    }

    return (
      <>
        <div className="navbar-style">
          <div className="navbar-inner-div-proxy">
            <div className="navbar-company-logo-styling">
              <img src={logo} alt="helpdesk-proxy-logo" />
            </div>
          </div>
        </div>
        <div className="app-div-style">
          <div className="login-box">
            <div className="auth-div-outer-style">
              <div className="login-form-style">
                <form className="helpdesk" onSubmit={this.submitEmail}>
                  <h2 className="helpdesk__h2">
                    Welcome to{" "}
                    {title === "Kaizen" ? "the Kaizen" : "Single Rulebook"}{" "}
                    Helpdesk
                  </h2>
                  <div className="helpdesk__divider" />
                  <p className="helpdesk__p">
                    Please enter your email address to sign in to{" "}
                    {title === "Kaizen" ? "the Kaizen" : "Single Rulebook"}{" "}
                    Helpdesk
                  </p>
                  <input
                    type="email"
                    placeholder="Email"
                    ref={this.updateEmail}
                    className={inputStyleClassName}
                  />
                  {!!errorMessage && (
                    <div>
                      <span className="helpdesk-error-message">
                        {errorMessage}
                      </span>
                    </div>
                  )}
                  <button
                    className={buttonStyleClassName}
                    type="submit"
                    style={{ backgroundColor: color }}
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

Support.propTypes = {
  cookies: PropTypes.shape({
    getAll: PropTypes.func,
    set: PropTypes.func,
  }).isRequired,
}

export default withCookies(Support)
